import { render } from "./ModalQuizProfile.vue?vue&type=template&id=2b1bdbf6"
import script from "./ModalQuizProfile.vue?vue&type=script&lang=js"
export * from "./ModalQuizProfile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__